import React, { useEffect, useState } from 'react';
import '../style.css';
import '../style/base.css';
import '../style/navbar.css';
import '../style/pages.css';
import '../style/responsive.css';
import '../style/sidebar.css';

const GravityTags = () => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);
  
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (!isDesktop) return;

    const createTag = () => {
      const tag = document.createElement('div');
      tag.classList.add('gravity-tag');
      tag.textContent = tags[Math.floor(Math.random() * tags.length)];
      tag.style.left = Math.random() * window.innerWidth + 'px';
      tag.style.backgroundColor = googleColors[Math.floor(Math.random() * googleColors.length)];
      tag.style.animationDuration = (Math.random() * 3 + 2) + 's';
      document.querySelector('.gravity-container').appendChild(tag);
      
      tag.addEventListener('animationend', () => tag.remove());
    };

    const tags = [
      'Motion Design',
  'Brand Design',
  'Visual Effects',
  'UI Animation',
  'AI Designer',
  'Prompt Engineer',
  'StableDiffusion',
  'ComfyUI',
  'FinTech Designer',
  'Creative Lead',
  'Motion Artist',
  'Video Editor',
  'Content Creator',
  'Python Base',
  'Cloud Expert',
  'Digital Artist',
  'Campaign Designer',
  'Brand Strategist',
  'Social Media',  
  'ComfyUI Workflows',
  'Web3 Creative',
  'Design Thinking',
  'Visual Designer',
  'Animation Lead',
  'Digital Marketing',
  'Corporate Design',
  'Banking Design',
  'YouTube Expert',
  'LinkedIn Creator',
  'Marketing Design',
  'Content Strategy',  
  'Creative Workflow',
  'AI Integration',
  'Design Systems',
  'Motion Graphics',
  'ComfyUI Nodes',
  'Brand Development',
  'Brand Identity'
    ];
  
    const googleColors = [
      '#4285f4', // Google Blue
      '#34a853', // Google Green  
      '#fbbc05', // Google Yellow
      '#ea4335', // Google Red
    ];

    const interval = setInterval(createTag, 500);
    return () => clearInterval(interval);
  }, [isDesktop]);

  return isDesktop ? <div className="gravity-container"></div> : null;
};

export default GravityTags;
